import { render, staticRenderFns } from "./form-brochure.vue?vue&type=template&id=ff50c60e&"
import script from "./form-brochure.vue?vue&type=script&lang=js&"
export * from "./form-brochure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports